<template>
  <div class="task-metadata">
    <div>
      <label>{{ $t('status') }}</label>
      <slot name="status">
        <Badge :theme="statusTheme[item.status]" :value="$tc(`taskStatus${Capitalize(item.status)}`)" />
      </slot>
    </div>

    <div class="task-metadata__type" v-if="item.type === 'complaint'">
      <label>{{ $tc('type', 1) }}</label>
      <Badge theme="error" :value="$tc(item.type)" />
    </div>

    <div>
      <label>{{ $t('deadline') }}</label>
      <div
        v-tooltip="{ content: daysToDeadline <= 3 ? dueAtFormatted : null }"
        :class="{ fade: !dueAt, 'text--error': daysToDeadline <= 3 }"
      >
        {{ dueAt || $tc('noDeadline') }}
      </div>
    </div>

    <div>
      <label>{{ $tc('tag', 2) }}</label>
      <Badge v-for="tag in item.tags" :key="tag" :value="tag" />
      <div v-if="!$path('tags.length', item)" class="fade text--small">{{ $t('noTags') }}</div>
    </div>

    <div>
      <label>{{ $tc('member', 2) }}</label>
      <Avatar
        v-if="$path('members.length', item)"
        :value="item.members.map(({ avatar, name }) => ({ src: avatar, name }))"
        size="small"
      />
      <Badge v-else :value="$tc('noMembers')" />
    </div>
    <div v-if="item.createdBy">
      <label>{{ $tc('createdBy', 2) }}</label>
      <Avatar :value="{ src: item.createdBy.avatar, name: item.createdBy.name }" size="small" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Capitalize } from '@/utils'
import ReferenceComponents from '@/components/Task/Reference'
import Badge from '@/components/Badge'
import Avatar from '@/components/Avatar'

const statusTheme = {
  undone: 'warning',
  reject: 'error',
  request: 'primary',
  done: 'success',
}

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      ReferenceComponents,
      statusTheme,
    }
  },
  methods: {
    Capitalize,
  },
  computed: {
    dueAtFormatted() {
      if (!this.item.dueAt) return
      return moment(this.item.dueAt).format('LL')
    },
    dueAt() {
      if (!this.item.dueAt) return
      if (this.daysToDeadline >= 5) return this.dueAtFormatted
      return moment(this.item.dueAt).from(moment())
    },
    daysToDeadline() {
      if (!this.item.dueAt) return
      return moment(this.item.dueAt).endOf('day').diff(moment().startOf('day'), 'days')
    },
  },
  components: {
    Badge,
    Avatar,
  },
}
</script>

<style lang="scss">
.task-metadata {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem 2rem;

  @include respond-below('phone') {
    grid-template-columns: 1fr;
  }

  & > div {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.5rem;
  }

  label {
    font-weight: normal;
    opacity: 0.7;
  }

  img {
    aspect-ratio: 1 / 1;
    height: 2rem;
    object-fit: cover;
    border-radius: 50%;
    margin-left: -0.7rem;

    border: 1px solid css-darken('border-color', 5%);
  }
}
</style>
